import { createTheme } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';

const theme = (direction = 'ltr') => 
  createTheme({
  direction,
  breakpoints: {
    values: {
      xs: 0,
      sm: 650,
      md: 1279,
      lg: 1350,
      xl: 1536,
      '2xl': 1730,
    },
  },
  palette: {
    customColors: {
      primaryText: 'rgba(47, 43, 61, 0.7)',
      secondaryText: '#475467',
      disabledOpacity: 0.5,
      // Named tokens for the values the supplier screens already use inline
      // (brand green, borders, text tints, status chips). Added with the
      // Coupons & Deals feature (COMY1-359) so new code reads them from the
      // theme instead of repeating raw hex/rgba.
      brand: 'rgba(37, 124, 109, 1)',
      brandHover: 'rgba(37, 124, 109, 0.9)',
      brandSoft: 'rgba(36, 139, 112, 0.08)',
      brandSoftStrong: 'rgba(36, 139, 112, 0.12)',
      brandBorder: 'rgba(36, 139, 112, 0.35)',
      brandBorderDashed: 'rgba(37, 124, 109, 0.5)',
      border: '#EAEAEA',
      borderMuted: 'rgba(230, 228, 235, 1)',
      divider: '#F1F1F1',
      surface: '#FFFFFF',
      surfaceMuted: 'rgba(248, 247, 250, 0.5)',
      neutralButton: 'rgba(150, 153, 164, 1)',
      neutralButtonHover: 'rgba(150, 153, 164, 0.9)',
      textStrong: 'rgba(47, 43, 61, 0.9)',
      textBody: 'rgba(47, 43, 61, 0.8)',
      textMedium: 'rgba(47, 43, 61, 0.7)',
      textSoft: 'rgba(47, 43, 61, 0.55)',
      textFaint: 'rgba(47, 43, 61, 0.45)',
      textDisabled: 'rgba(47, 43, 61, 0.25)',
      iconMuted: 'rgba(47, 43, 61, 0.6)',
      chipBg: 'rgba(47, 43, 61, 0.06)',
      tooltipBg: '#2F2B3D',
      danger: '#C83737',
      dangerSoft: 'rgba(200, 55, 55, 0.08)',
      warning: 'rgba(180, 120, 20, 1)',
      warningSoft: 'rgba(255, 244, 229, 1)',
      warningBorder: 'rgba(180, 120, 20, 0.35)',
      info: '#5A67D8',
      infoSoft: 'rgba(90, 103, 216, 0.12)',
      statusActive: '#248B70',
      statusPaused: '#8F6110',
      statusPending: '#B47814',
      statusExpired: 'rgba(71, 84, 103, 1)',
      statusExpiredSoft: 'rgba(71, 84, 103, 0.10)',
      overlay: 'rgba(0, 0, 0, 0.5)',
      shadow: '0 8px 24px rgba(0, 0, 0, 0.10)',
    },
  },
  typography: {
    allVariants: {
      color: 'rgba(47, 43, 61, 0.9)',
    },
  },
});
theme.stylisPlugins = [prefixer, rtlPlugin];
export default theme;
